module.exports = __webpack_public_path__ + "static/media/icon-social-likes.a303b0d8.svg";